import React from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { IncidentSubClassification } from '@models/Incident';
import { TemperatureCard } from '@views/ApartmentPage/components/FeatureCards';

import { ApartmentDefectCommonForm } from '../components/ApartmentDefectCommonForm';

export const ApartmentDefectTemperature = (props: ParsedEntry<IWidget>) => (
  <>
    <TemperatureCard className="mb-5 sm:w-fit" />

    <ApartmentDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.APARTMENT_TEMPERATURE}
    />
  </>
);
